import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentUser, logoutUser, fetchUserByToken } from 'store';
import { useDispatchContext, initialState } from 'context';
import { useNavigate } from 'react-router-dom';
import { getEnv, getQueryString, resetAccount } from 'utils';

function ChatbotLogout() {
  const dispatch = useDispatch();
  const dispatchContext = useDispatchContext();
  const isLoggedIn = useSelector((state) => state.authReducer.isLoggedIn);
  const token = useSelector(
    (state) => state.accountReducer.currentUser?.access_token || ''
  );

  const queryString = getQueryString();

  const navigate = useNavigate();
  useEffect(() => {
    const logout = async () => {
      try {
        const currentUser = await dispatch(fetchCurrentUser()).unwrap();
        let user = null;
        if (queryString?.token) {
          user = await dispatch(fetchUserByToken(queryString?.token)).unwrap();
        }

        if (isLoggedIn && !queryString?.token) {
          window.open(
            `${getEnv(
              'REACT_APP_CHATBOT_URL'
            )}/auth/callback?token=${token}&from=${window.location.origin}`,
            '_self'
          );
          return;
        }

        if (currentUser?.id === user?.id) {
          await dispatch(logoutUser()).unwrap();
          dispatchContext({ type: 'logout', ...initialState });
          navigate('/login');
        } else navigate('/');
      } catch (error) {
        if (error.response.status === 401) {
          resetAccount();
          navigate('/login');
        }
      }
    };
    logout();
  }, [dispatch]);

  return null;
}

export default ChatbotLogout;
